const { config } = require("../../../package.json");
const { getPublicApiKey } = require("../public-api-key");

const alias = (() => {
    return config.serviceProfile ? `/${config.serviceProfile}` : "";
})();

function getApiEndpoint() {
    if (config["isCloudDeployment"]) {
        return `https://api-eu.revrec.chargebee.com${alias}`;
    } else {
        return "http://localhost:3001";
    }
}

const baseRedirectUrl = (() => {
    return "https://app-eu.revrec.chargebee.com";
})();

const baseReportUrl = (() => {
    return "https://reports-eu.revrec.chargebee.com";
})();

export default {
    microstrategy: {
        mstrWebUrl: `${baseReportUrl}/MicroStrategy/servlet/`,
        project: "Prod_RL_B",
        server: `mstr-is.prod-eu.revrec.local`
    },
    hotGlue: {
        env_id: "prod-eu.hotglue.rev-lock.com"
    },
    AWS: {
        API: {
            endpoints: [
                {
                    name: "revlock_api",
                    endpoint: getApiEndpoint()
                },
                {
                    name: "revlock_public_api",
                    endpoint: getApiEndpoint(),
                    custom_header: async () => {
                        return {
                            "x-api-key": getPublicApiKey("prod-eu")
                        };
                    }
                }
            ]
        },
        Auth: {
            identityPoolId: "eu-central-1:dcbcec45-d0d7-4007-ab92-3670506d5a1f",
            region: "eu-central-1",
            userPoolId: "eu-central-1_fnz1KYR5h",
            userPoolWebClientId: "3pu6q5g05dpkpgffmmao3phgjj",
            mandatorySignIn: true
        },
        Storage: {
            bucket: "cb-revrec-prod-eu-c1-userfiles",
            region: "eu-central-1",
            hotglueBucket: "cb-revrec-prod-eu-c1-hotgluefiles"
        },
        Analytics: {
            disabled: true
        },
        oauth: {
            domain: "auth-eu.revrec.chargebee.com",
            clientId:
                "1092057117597-5m0ml54tve0hha8v79pccob3l6320sno.apps.googleusercontent.com",
            redirectSignOut: `${baseRedirectUrl}/signout`,
            redirectSignIn: `${baseRedirectUrl}/`,
            scope: ["email", "profile", "openid"],
            responseType: "code"
        }
    },
    analytics: {
        trackingId: "UA-127158128-2",
        debug: false
    },
    keycloakConfig: {
        url: "https://idp-broker.devcb.in/",
        redirectUri: `https://prod-${config.serviceProfile}-sso.rev-lock.com/`,
        realm: "master",
        clientId: "revrec-app",
        idpHint: "revrec-idp",
        redirectSignoutUri: `https://prod.auth.rev-lock.com/logout?client_id=6f50lh83rprtp3pl1sof5edsdn&logout_uri=https%3A%2F%2Fprod-${config.serviceProfile}-sso.rev-lock.com%2F`
    },
    copilotWidgetUrl:
        "https://cdn.ai.chargebee.com/copilot-ui/assets/copilot-embed.js",
    wsBaseUrl: "wss://wsapi-eu.revrec.chargebee.com",
    reportsV2ApiUrl: "https://prod-reports-v2-eu.revrec.chargebee.com/api"
};
